var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticon-workpackage-component",style:(`
    width: ${_vm.icon_size}px;
    height: ${_vm.icon_size}px;
    background-color: ${_vm.getColor(_vm.workpackage.color)};
  `)},[_c('TIcon',{attrs:{"name":_vm.workpackage.icon,"size":_vm.icon_size - 4,"color":_vm.getColor(_vm.workpackage.textcolor)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }